import './AccordionPanel.css';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {AccordionDropdown} from './AccordionDropdown/AccordionDropdown';

export function AccordionPanel(props) {
  const {accordionDropDownValues, accordionTitle} = props;
  return (
    <>
      <div className={cx('prequal--web--accordion-heading-title')} data-testid='accordion-title'>
        {' '}
        {accordionTitle}
      </div>
      <div data-testid='accordion-content' className='prequal--web--accordion-content'>
        {accordionDropDownValues.map((value, idx) => (
          <AccordionDropdown key={`FAQ-${idx + 1}`} title={value.title} content={value.content} accordionBorder={value.border} />
        ))}
      </div>
    </>
  );
}

AccordionPanel.propTypes = {accordionDropDownValues: PropTypes.array, accordionTitle: PropTypes.string};
AccordionPanel.defaultProps = {accordionDropDownValues: [], accordionTitle: ''};
